export const winRatioChartConfig = {
  height: 400,
  minHeight: 400,
  titleAlign: "left" as const,
  barWidth: "35%",
  legendTop: 8,
  legendRight: 50,
  xAxisRotateThreshold: 5,
};
